<template>
  <div class="dash-upload" :class="[size]">
    <el-upload
      class="picture-uploader"
      action=""
      ref="uploader"
      v-loading="loading"
      :class="{'picture-uploader-disabled': disabled}"
      :disabled="disabled"
      :accept="fileType"
      :show-file-list="false"
      :http-request="uploadPicture"
      :before-upload="beforeUpload"
    >
      <img v-if="imgUrl" :src="imgUrl" class="picture" />
      <video
        v-if="videoUrl"
        :src="videoUrl"
        class="picture"
        id="video"
        controls
      ></video>

      <div v-if="!imgUrl && !videoUrl">
        <i class="iconfont iconAdd"></i>
        <p v-if="media === 'picture'">{{ $t('Add picture') }}</p>
        <p v-if="media === 'picture'">
          {{ tips || $t('Only support png & jpg, less than 1Mb') }}
        </p>
        <p v-if="media === 'video'">{{ $t('Add video') }}</p>
        <p v-if="media === 'video'">
          {{ $t('Only support mp4, less than 10Mb') }}
        </p>
      </div>
    </el-upload>
    <div class="utils" :class="[layout]" v-if="(imgUrl || videoUrl) && !disabled">
      <div class="btn" @click="triggerUpload">{{ $t('Upload again') }}</div>
      <div class="btn" @click="del">{{ $t('del') }}</div>
    </div>
  </div>
</template>
<script>
import {uploadImageByBaseStr } from '@/api/index'

export default {
  name: 'dash-upload',
  data() {
    return {
      loading: false,
      imgUrl: '',
      videoUrl: '',
      fileType: ''
    }
  },

  props: {
    // 上传文件的类型
    accept: {
      default: 'image/jpg,image/jpeg,image/png,image/gif',
      type: String
    },
    // 上传媒体类型： picture / video
    media: {
      type: String,
      default: 'picture'
    },
    // 功能文字位置： bottom / right
    layout: {
      type: String,
      default: 'bottom'
    },
    //尺寸： small / medium / large / square
    size: {
      type: String,
      default: 'small'
    },
    // 已上传文件路径
    mediaUrl: {
      type: String,
      default: ''
    },
    // 视频缩略图
    advertsVideoImage: {
      type: String,
      default: ''
    },
    // 是否不可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    }
  },

  watch: {
    mediaUrl: function() {
      this.init()
    }
  },

  mounted() {
    this.fileType = this.accept
    this.init()
  },

  methods: {
    init() {
      if (this.media === 'picture') {
        this.imgUrl = this.mediaUrl
      }

      if (this.media === 'video') {
        this.videoUrl = this.mediaUrl
        this.fileType = '.mp4,.avi,.wmv,.mpg,.mpeg,.3gp,.mov,.flv,.rmvb,.vob,.mkv'
      }
    },
    getVideoFirstImg() {
      let video = document.getElementById('video')
      // let _this = this;
      // video.currentTime = 0.001;
      video.addEventListener("loadeddata", function() {
        var canvas = document.createElement("canvas")
        canvas.width = video.videoWidth * .5
        canvas.height = video.videoHeight * .5
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        // var dataURL = canvas.toDataURL('image/png')
        // _this.$emit('update:advertsVideoImage', dataURL)
      })
    },
    uploadPicture(req) {
      const reader = new FileReader()
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        function getType(file){
            var filename=file;
            var index1=filename.lastIndexOf(".");
            var index2=filename.length;
            var type=filename.substring(index1,index2);
            var name=(parseInt(Math.random()*100000000)).toString()
            return [name, type]
        }
        let names = getType(req.file['name'])
        names[0] = names[0].replace(/,/g, '')
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: 'xiezhan/' + names[0] + "_" + (new Date()).valueOf() + names[1],
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }

        // 视频
        let config = {}
        if (this.media === 'video') {
          params.bucketName = 'ef-imaster-file'
          config.onUploadProgress = progressEvent => {
            let percent=(progressEvent.loaded / progressEvent.total * 100) | 0
            //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
            console.log(percent, progressEvent)
          }
        }

        uploadImageByBaseStr(params, config).then(res => {
          if (this.media === 'video') {
            this.videoUrl = res.data.data
          } else {
            this.imgUrl = res.data.data
          }
          this.$emit('update:mediaUrl', res.data.data)
        }).finally(() => {
          this.loading = false
        })
    }
    },

    beforeUpload(file) {
      this.loading = true

      if (this.media === 'picture') {
        // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.loading = false
          this.$message.error(
            this.$t('Uploaded image can not greater than 1Mb')
          )
        }
        return isLt2M
      }

      if (this.media === 'video') {
        // const isMP4 = file.type === 'video/mp4'
        const isLt = file.size / 1024 / 1024 < 100
        if (!isLt) {
          this.loading = false
          this.$message.error(
            this.$t('Uploaded video can not greater than 10Mb')
          )
        }
        return isLt
      }
    },

    triggerUpload() {
      this.$refs.uploader.$refs['upload-inner'].$refs['input'].click()
    },

    del() {
      this.imgUrl = ''
      this.videoUrl = ''
      this.$emit('update:mediaUrl', '')
    }
  }
}
</script>
<style lang="stylus">
.dash-upload
  width 230px

  padding-bottom 40px
  position relative

  .picture-uploader .el-upload
    border 1px solid $color-gray-d9
    width 100%
    height 100%
    cursor pointer
    position relative
    overflow hidden
    line-height 2
    font-size 12px
    text-align center
    display flex
    flex-direction column
    align-items center
    justify-content center
    color $color-black-65
    font-weight: 400
  .iconAdd
    color $color-main
    width 23px
    height 23px
    font-size 23px
  .picture-uploader .el-upload:hover
    border-color $color-main

  &.medium
    width: 27vw
  &.large
    width: 70%
  &.large-y
    width: 460px
  &.square
    width 230px
  &.small .picture-uploader
    width 100%
    height 118px
  &.large .picture-uploader
    height 22.778vw
    width: 100%
  &.large-y .picture-uploader
    height 640px
    width: 100%
  &.medium .picture-uploader,
  &.square .picture-uploader
    height 230px
    width 230px
  &.square-small .picture-uploader{
    height: 180px;
    width: 180px;
  }
  &.square-small-a
    width: 206px;
   .picture-uploader{
    height: 206px;
    width: 206px;
  }

  .picture-uploader-disabled {
    .el-upload{
      border-color: $color-black-25
      
      .iconAdd {
        color: $color-black-25
      }

      &:hover{
        cursor: not-allowed
        border-color: $color-black-25
      }
    }
  }
  
  .picture
    width 100%
    height 100%
    display block
    object-fit contain
  .utils
    color $color-main
    position absolute
    bottom 12px
    right 2px
    line-height normal
    &.right
      left: 102%;
      bottom: 40px;
      width: 100%;
    .btn
      display inline-block
      margin-left 12px
      font-size 14px
      line-height 1.5
      cursor pointer
      font-weight: 400
      &:hover
        color $color-main-hover
</style>
